// eslint-disable-next-line import/no-named-as-default -- posthog-js re-exports its own default as a named `posthog` too
import posthog from 'posthog-js';

import { env } from './environment-config';

// PostHog's project token is injected at container startup by entrypoint.sh
// (same mechanism as window.DS3_ENV, HEAP_APP_ID, and the old CLARITY_PROJECT_ID),
// not via Vite's build-time import.meta.env -- this app builds once and deploys the
// same image to integ/staging/prod, so a build-time env var would bake in one value
// for every environment. Locally, entrypoint.sh never runs, so this falls back to
// VITE_PUBLIC_POSTHOG_PROJECT_TOKEN for local dev testing.
//
// The host is not injected: every environment points at the same PostHog Cloud
// region, so there is nothing to vary per deploy, and injecting it anyway would
// let a real token pair with a wrong/missing host if the two substitutions ever
// drifted independently.
function isUnsubstituted(value: string | undefined): boolean {
  return !value || value.startsWith('__REPLACE_ME_FROM_ENTRYPOINT__');
}

const windowToken: string | undefined = window.POSTHOG_PROJECT_TOKEN;

export const POSTHOG_PROJECT_TOKEN = isUnsubstituted(windowToken)
  ? import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN || ''
  : windowToken;
export const POSTHOG_HOST = 'https://us.i.posthog.com';

// Kill switch: PostHog is paused for DS3. The integration is left intact rather
// than reverted, so re-enabling is a one-line flip back to false.
export const POSTHOG_DISABLED = true;

export const isPostHogConfigured = !POSTHOG_DISABLED && Boolean(POSTHOG_PROJECT_TOKEN && POSTHOG_HOST);
export const IS_DEV = import.meta.env.DEV;

// posthog.reset() clears all persisted state, including super-properties set
// via register() -- callers must use resetPostHog() instead of posthog.reset()
// directly so environment/product tagging survives logout and user switches.
export function registerAnalyticsProperties(): void {
  posthog.register({ environment: env, product: 'sender-ui' });
}

export function resetPostHog(): void {
  posthog.reset();
  registerAnalyticsProperties();
}
